import useAppMain from "src/hooks/useAppMain";
import { CLIENT_TAB_LIST } from "src/utils/constants";
import { useState } from "react";
import { Tabs, useMantineTheme } from "@mantine/core";
import Transactions from "./Transactions";
import Attendance from "./Attendance";

enum TabsName {
  TRANSACTIONS = "Transactions",
  ATTENDANCE = "Attendance",
}

export default function Record() {
  useAppMain(CLIENT_TAB_LIST.MY_RECORDS, false);
  const theme = useMantineTheme();
  const [currentTab, setCurrentTab] = useState<TabsName>(TabsName.TRANSACTIONS);

  const updateTab = (tabName: TabsName) => {
    setCurrentTab(tabName);
  };

  return (
    <>
      <Tabs
        sx={{
          ".mantine-Tabs-tab[data-active='true']": {
            fontWeight: 600,
          },
        }}
        styles={(theme) => ({
          tabsList: {
            borderBottom: 0,
            justifyContent: "center",
          },
          tab: {
            minWidth: "38vw",
            color: theme.colors.gray[6],
            fontWeight: 400,
            fontSize: "1em",
          },
        })}
        value={currentTab}
        onTabChange={updateTab}
      >
        <Tabs.List mb={"lg"}>
          {Object.values(TabsName).map((e) => (
            <Tabs.Tab
              key={e}
              value={e}
              style={{ color: theme.colors.secondaryTextColor[6] }}
            >
              {e}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        <Tabs.Panel value={TabsName.TRANSACTIONS}>
          <Transactions />
        </Tabs.Panel>

        <Tabs.Panel value={TabsName.ATTENDANCE}>
          {currentTab === TabsName.ATTENDANCE && <Attendance />}
        </Tabs.Panel>
      </Tabs>
    </>
  );
}
